import { UserMemberCreated, UserMemberPost } from "@gymflow/types";

import endpoints from "./endpoints";
import { trimFields } from "./features/trimFiels";
import { createPublicAxiosInstance } from "./publicAxiosInstance";

export type PublicUserMemberApiType = ReturnType<typeof publicUserMemberApi>;

const publicUserMemberApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = [
    "firstName",
    "lastName",
    "mobileNumber",
    "dateBirth",
    "postCode",
    "addressLine1",
    "addressLine2",
    "city",
    "email",
    "emergencyContact",
    "emergencyContactName",
    "username",
  ];
  const axiosInstance = createPublicAxiosInstance({
    apiUrl,
  });

  return {
    create(newResource: UserMemberPost) {
      return axiosInstance.post<{ userMember: UserMemberCreated }>(
        `${clubPrefix}${endpoints.publicUserMember}`,
        trimFields(newResource, fieldsToTrim),
      );
    },

    emailExists(email: string) {
      return axiosInstance.get(`${clubPrefix}hosted/catalog/user/email/check`, {
        params: { q: email.toLowerCase() },
      });
    },
  };
};

export default publicUserMemberApi;
